import { DetailsParams } from './slice/types'

type Path = string

export type CollectionState = Record<Path, { details?: DetailsParams }>

export const initialState: CollectionState = {}
